import { useSelector } from "react-redux";
import MobileActionHeader from "../../../../components/UI/headingsUI/MobileActionHeader";
import FilterSearch from "../../../../components/common/FilterSearch";
import { SITE_REPAIRS_FILTERS } from "../../../../utils/filterCategoryList";
import { SITE_REAPER_SEARCH_OPTIONS } from "../../../../utils/tableSearchList";
import { RepairsTableView } from "./RepairsTableView";
import { formatRepairExcelData } from "../../utils/excelFormatters";

const StationRepairList = () => {
    const originalSitesData = useSelector((state) => state.data.copyData);
    // ...............get  excel data............
    const excelData = formatRepairExcelData(originalSitesData);
    const excelConfig = {
      data: excelData,
      fileName: "Station_Repairs_Data",
      sheetName: "Station Repairs",
    };
  
  return (
    <>
      <MobileActionHeader
        title="Station Repairs"
        navigate={"/site/add-repair-work"}
        btnText={"Add Repair"}
      />
      <FilterSearch
        categories={SITE_REPAIRS_FILTERS}
        searchCategories={SITE_REAPER_SEARCH_OPTIONS}
        addBtnNavigation={"/site/add-repair-work"}
        addBtnText={"Add Repair"}
         excelConfig={excelConfig}
      />
      <RepairsTableView />
    </>
  );
};
export default StationRepairList;
